import API from '../../../services/apiService.js'

var api= new API();


export default {

  async getChatNotifies({commit}){
    var data=[];
    try{
      data =  api.Get("Chat/GetChatCounter");
      let count= await data.reduce((a, b)=>{return a+b.clientNewMessageCount}, 0);
      let res={
        code:1,
        count:count
      }
      commit('loadNotifyCounts', res);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить уведомление из списка
  removeNotification({commit}, code){
    commit("clearNotifyCount", code);
  },

  //добавить уведомление в список code: 0 - заявка, 1 - сообщение
  addNotification ({commit}, code){
    commit("addNotify", code)
  }




}
